<template>
  <a-row :gutter="10" style="margin-top: 10px">
    <a-form :layout="formLayout" labelAlign="left" :form="searchForm" @submit="handleSubmit">
      <a-col :span="6">
        <a-form-item label="起始地点" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
              allowClear
              show-search
              :filter-option="filterOption"
              placeholder="请选择起始地点"
              v-decorator="['start_address_id']"
          >
            <a-select-option v-for="item in addressList" :value="item.address_id">
              {{ item.address_name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="6">
        <a-form-item label="到达终点" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
              allowClear
              show-search
              :filter-option="filterOption"
              placeholder="请选择到达终点"
              v-decorator="['end_address_id']"
          >
            <a-select-option v-for="item in addressList" :value="item.address_id">
              {{ item.address_name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <!--        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
        <!--          <a-select-->
        <!--              allowClear-->
        <!--              v-decorator="['status']"-->
        <!--              :options="[{ label: '启用', value: 0 },{ label: '停用', value: 1 }]"-->
        <!--              placeholder="请选择状态"-->
        <!--          />-->
        <!--        </a-form-item>-->

      </a-col>
      <a-col :span="6">
        <a-form-item label="装货品名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
              allowClear
              show-search
              :filter-option="filterOption"
              placeholder="请选择装货品名"
              v-decorator="['goods_id']"
          >
            <a-select-option v-for="item in goodsList" :value="item.goods_id">
              {{ item.goods_name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <!--      <a-col :span="8">-->
      <!--        <a-form-item label="创建时间" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
      <!--          <a-range-picker-->
      <!--              allowClear-->
      <!--              format="YYYY-MM-DD"-->
      <!--              v-decorator="['create_time']"-->
      <!--          />-->
      <!--        </a-form-item>-->
      <!--      </a-col>-->
      <a-col :span="6">
        <a-form-item :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-button style="margin-right: 10px" type="primary" html-type="submit" icon="search">搜索</a-button>
          <a-button @click="handleReset">重置表单</a-button>
        </a-form-item>
      </a-col>
    </a-form>
  </a-row>
</template>
<script>
import {SelectRegion} from '@/components'

export default {
  name: 'searchForm',
  props: ['addressList','goodsList'],
  components: {
    SelectRegion
  },
  data() {
    return {
      searchForm: this.$form.createForm(this),
      queryParam: {},
      formLayout: 'horizontal',
      labelCol: {
        style: 'width: 70px;float:left;margin-right:10px;white-space: nowrap;\n' +
            'text-overflow: ellipsis;\n' +
            '-o-text-overflow: ellipsis;\n' +
            'overflow: hidden;'
      },
      wrapperCol: {style: 'width: calc( 95% - 70px );float:left'},

      //类型
      options: [
        {lable: '保养', value: 0},
        {lable: '维修', value: 1},
        {lable: '其他', value: 2}
      ]
    }
  },
  methods: {
    // 多选框搜索配置
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleSubmit(e) {
      e.preventDefault()
      const {searchForm: {validateFields}} = this
      validateFields((errors, values) => {
        if (errors) {
          return false
        }
        this.$emit('handleSubmit', values)
      })
    },
    handleReset() {
      this.searchForm.resetFields()
    }
  }
}
</script>
<style scoped lang="less">

</style>
